export default "__VITE_ASSET__291fb4e7__"